import { InjectionToken } from '@angular/core';
import {
  Authenticator,
  CommandQueueCleaner,
  CommandQueueRunner,
  DatabaseCreator,
  MaintenanceSynchroniser,
  MaintenanceWatchStarter,
  RootHistorySetter,
  ShutdownInfoListener,
  SyncIndicatorCloser,
  SyncIndicatorOpener,
  SyncIndicatorPreCloser,
  SyncStarter,
  TokenHandler,
  WebSyncStarter,
} from '../contracts/sync/sync-endpoints';

export const syncOrder = [
  SyncIndicatorPreCloser,
  TokenHandler,
  Authenticator,
  DatabaseCreator,
  CommandQueueCleaner,
  MaintenanceSynchroniser,
  MaintenanceWatchStarter,
  ShutdownInfoListener,
  CommandQueueRunner,
  RootHistorySetter,
  SyncIndicatorOpener,
  SyncStarter,
  WebSyncStarter,
  SyncIndicatorCloser,
];

export const SyncOrderToken = new InjectionToken<string[]>('SyncOrder', {
  providedIn: 'root',
  factory: () => syncOrder,
});
